import { Input, Menu } from "antd";
import styled from "styled-components";

import { BILLING_TOKENS as C } from "../components/designTokens";

/* Styled building blocks for the Members page (extracted from Members.tsx so the page file
 * holds behavior, not presentation). */

export const Page = styled.div`
  color: ${C.text};
  padding-bottom: 96px;
`;
export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: flex-start;
`;
export const MainCol = styled.div`
  width: 60%;
  min-width: 0;
`;
export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
  width: 60%;
`;
export const Title = styled.div`
  font-size: 30px;
  font-weight: 900;
  letter-spacing: -0.01em;
  color: ${C.heading};
`;
export const Subtitle = styled.div`
  font-size: 14px;
  color: ${C.muted};
  margin-top: 4px;
`;
export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;
export const Search = styled(Input)`
  width: 230px;
  height: 40px;
  border-radius: 8px;
  border-color: ${C.border};
`;
export const FilterBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid ${C.border};
  border-radius: 8px;
  background: ${C.surface};
  font-size: 14px;
  color: ${C.text};
  cursor: pointer;
  &:hover {
    border-color: ${C.blue};
  }
`;
export const PrimaryBtn = styled.button<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: ${p => (p.disabled ? C.blueDisabled : C.blue)};
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: ${p => (p.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: ${p => (p.disabled ? C.blueDisabled : C.blueHover)};
  }
`;
export const OutlineBtn = styled.button`
  height: 34px;
  padding: 0 14px;
  border: 1px solid ${C.border};
  border-radius: 8px;
  background: ${C.surface};
  font-size: 13px;
  font-weight: 500;
  color: ${C.text};
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    border-color: ${C.blue};
    color: ${C.blue};
  }
`;
export const GhostBtn = styled.button`
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 8px;
  background: none;
  font-size: 15px;
  font-weight: 700;
  color: ${C.text};
  cursor: pointer;
  &:hover {
    background: ${C.sunken};
  }
`;

export const InfoBanner = styled.div`
  background: ${C.blue50};
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  .t {
    font-size: 14px;
    font-weight: 600;
    color: ${C.heading};
  }
  .s {
    font-size: 13px;
    color: ${C.muted};
    margin-top: 2px;
  }
`;
export const PlanSummary = styled.div`
  border: 1px solid ${C.divider};
  border-radius: 10px;
  padding: 6px 20px;
  margin-bottom: 28px;
`;
export const PlanRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 0;
  & + & {
    border-top: 1px solid ${C.divider};
  }
  .seats {
    flex: 1;
    font-size: 14px;
    color: ${C.muted};
    b {
      font-size: 16px;
      color: ${C.heading};
      margin-right: 5px;
    }
  }
`;

export const gridCols = "minmax(0, 1fr) 150px 230px 44px";
export const ColHeader = styled.div`
  display: grid;
  grid-template-columns: ${gridCols};
  gap: 12px;
  padding: 0 8px 10px;
  align-items: center;
  .c {
    font-size: 12px;
    font-weight: 600;
    color: ${C.placeholder};
  }
  .userCol {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;
export const GroupHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 18px 8px 6px;
  .t {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: ${C.placeholder};
    text-transform: uppercase;
  }
  .m {
    font-size: 12px;
    color: ${C.placeholder};
  }
`;
export const Row = styled.div<{ selected?: boolean }>`
  display: grid;
  grid-template-columns: ${gridCols};
  gap: 12px;
  align-items: center;
  padding: 11px 8px;
  border-bottom: 1px solid ${C.divider};
  background: ${p => (p.selected ? C.rowSel : "transparent")};
  &:hover {
    background: ${p => (p.selected ? C.rowSel : C.rowHover)};
  }
  &.selRow:hover .av {
    display: none;
  }
  &.selRow:hover .ck {
    display: flex;
  }
`;
export const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;
export const CheckBox = styled.span<{ checked?: boolean; indeterminate?: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid ${p => (p.checked || p.indeterminate ? C.blue : C.faint)};
  background: ${p => (p.checked || p.indeterminate ? C.blue : C.surface)};
  color: #fff;
  font-size: 11px;
  cursor: pointer;
  &:hover {
    border-color: ${C.blue};
  }
`;
export const AvatarWrap = styled.div<{ selectable: boolean; sel: boolean; selMode: boolean }>`
  position: relative;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${p => (p.selectable ? "pointer" : "default")};
  .av,
  .ck {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .av {
    display: ${p => (p.selectable && (p.sel || p.selMode) ? "none" : "flex")};
  }
  .ck {
    display: ${p => (p.selectable && (p.sel || p.selMode) ? "flex" : "none")};
  }
`;
export const Avatar = styled.div<{ bg: string }>`
  width: 36px;
  height: 36px;
  border-radius: 100px;
  background: ${p => p.bg};
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DashedAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 100px;
  flex-shrink: 0;
  border: 1.5px dashed ${C.border};
  color: ${C.placeholder};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const NameCol = styled.div`
  min-width: 0;
  .name {
    font-size: 14px;
    font-weight: 600;
    color: ${C.text};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .email {
    font-size: 13px;
    color: ${C.placeholder};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const Pill = styled.span<{ bg: string; fg: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 100px;
  background: ${p => p.bg};
  color: ${p => p.fg};
  font-size: 13px;
  font-weight: 500;
`;
export const Badge = styled.span<{ bg: string; fg: string }>`
  display: inline-block;
  padding: 2px 9px;
  border-radius: 5px;
  background: ${p => p.bg};
  color: ${p => p.fg};
  font-size: 11px;
  font-weight: 700;
`;
export const OutlineTag = styled.span`
  display: inline-block;
  padding: 1px 8px;
  border-radius: 5px;
  border: 1px solid ${C.border};
  color: ${C.muted};
  font-size: 11px;
  font-weight: 500;
`;
export const PlanCol = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const LinkBtn = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${C.blue};
  cursor: pointer;
  &:hover {
    color: ${C.blueHover};
  }
`;
export const Kebab = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  color: ${C.muted};
  font-size: 18px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 6px;
  &:hover {
    background: ${C.sunken};
  }
`;
/* Kebab dropdown panel styled to the design: 276px card, 10px uppercase section headers,
 * 13px items with 16px icons, subtle hover, red destructive hover. */
export const RowMenu = styled(Menu)`
  &.ant-dropdown-menu {
    width: 276px;
    padding: 6px;
    border-radius: 10px;
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.14);
  }
  .ant-dropdown-menu-item-group-title {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${C.placeholder};
    padding: 6px 10px 5px;
  }
  .ant-dropdown-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 6px;
    font-size: 13px;
    color: ${C.text};
    .anticon {
      font-size: 15px;
      color: ${C.muted};
      margin-right: 0;
    }
    .ant-dropdown-menu-title-content {
      flex: 1;
    }
    &:hover {
      background: ${C.sunken};
    }
  }
  .ant-dropdown-menu-item-danger {
    color: ${C.danger} !important;
    .anticon {
      color: ${C.danger};
    }
    &:hover {
      background: ${C.dangerBg} !important;
      color: ${C.danger} !important;
    }
  }
  .ant-dropdown-menu-item-disabled {
    color: ${C.faint} !important;
    .anticon {
      color: ${C.faint};
    }
    &:hover {
      background: transparent;
    }
  }
  .ant-dropdown-menu-item-divider {
    background: ${C.divider};
    margin: 6px 4px;
  }
`;
export const EmptyState = styled.div`
  padding: 56px 0;
  text-align: center;
  .t {
    font-size: 16px;
    font-weight: 600;
  }
  .s {
    font-size: 14px;
    color: ${C.placeholder};
    margin-top: 4px;
  }
`;

/* Bulk action bar — white pill, matches design */
export const BulkBar = styled.div`
  position: sticky;
  bottom: 24px;
  margin: 20px auto 0;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${C.surface};
  border: 1px solid ${C.divider};
  border-radius: 10px;
  box-shadow: 0 3px 18px rgba(0, 0, 0, 0.18);
  padding: 8px 10px;
  z-index: 90;
  .count {
    font-size: 14px;
    font-weight: 700;
    color: ${C.text};
    padding: 0 8px;
  }
  .sep {
    width: 1px;
    height: 22px;
    background: ${C.divider};
    margin: 0 4px;
  }
  .act {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: none;
    color: ${C.text};
    font-size: 13px;
    font-weight: 500;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      background: ${C.sunken};
    }
  }
  .danger {
    color: ${C.danger};
    &:hover {
      background: ${C.dangerBg};
    }
  }
  .x {
    color: ${C.muted};
  }
`;

/* ---- Modals ---- */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
export const ModalCard = styled.div<{ wide?: boolean }>`
  width: ${p => (p.wide ? "600px" : "480px")};
  max-width: calc(100vw - 40px);
  background: ${C.surface};
  border-radius: 12px;
  box-shadow: 0 3px 18px rgba(0, 0, 0, 0.18);
  padding: 26px 30px 30px;
`;
export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .title {
    font-size: 22px;
    font-weight: 800;
    color: ${C.heading};
  }
  .sub {
    font-size: 13px;
    color: ${C.placeholder};
    margin-top: 4px;
  }
  .close {
    border: none;
    background: none;
    cursor: pointer;
    color: ${C.placeholder};
    font-size: 16px;
    &:hover {
      color: ${C.text};
    }
  }
`;
export const RoleOption = styled.button<{ selected: boolean; disabled?: boolean }>`
  display: flex;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 16px;
  border-radius: 8px;
  cursor: ${p => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  background: ${p => (p.selected ? C.blue50 : C.sunken)};
  border: 1px solid ${p => (p.selected ? C.blue : C.borderSubtle)};
  .radio {
    width: 18px;
    height: 18px;
    border-radius: 100px;
    flex-shrink: 0;
    margin-top: 2px;
    border: 2px solid ${p => (p.selected ? C.blue : C.faint)};
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 100px;
    background: ${C.blue};
  }
  .label {
    font-weight: 600;
    color: ${p => (p.selected ? C.blue : C.heading)};
  }
  .desc {
    font-size: 14px;
    color: ${C.muted};
    margin-top: 4px;
  }
`;
export const WarnBox = styled.div`
  background: ${C.pendingBg};
  color: ${C.proFg};
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 14px;
  line-height: 20px;
  margin: 16px 0 20px;
`;
export const ChipInput = styled.div`
  border: 1px solid ${C.border};
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 96px;
  align-content: flex-start;
  input {
    border: none;
    outline: none;
    flex: 1;
    min-width: 140px;
    font-size: 14px;
  }
`;
export const Chip = styled.span<{ bad?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${p => (p.bad ? C.dangerBg : C.blue50)};
  color: ${p => (p.bad ? C.danger : C.blue)};
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 13px;
  .x {
    cursor: pointer;
    font-size: 11px;
  }
`;
